import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper'
import { EVC1_SCOOTER_IMG_SWIPER_INFO } from 'assets/json/scooterInfo.js'
// Import Swiper styles start
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/scrollbar'
// Import Swiper styles end

/**
 * @file 스마트스쿠터 화면에서 상단의 스쿠터 타입 영역의 swiper
 */
function ScooterEvC1SwiperFive() {
    const settings = {
        className: 'evc1_scooter_img_swiper',
        direction: 'horizontal',
        //slidesPerView: 3, // 한 화면에 보이는 슬라이드 수
        //spaceBetween: 0, // px 단위 간격
        loop: false,
        modules: [Navigation],
        navigation: {
            // 네비게이션 적용, < >
            nextEl: '.evc1_ten_swiper_btn.next', // 다음 버튼 클래스명
            prevEl: '.evc1_ten_swiper_btn.prev', // 이전 버튼 클래스명
        },
        breakpoints: {
            376: {
                slidesPerView: 1,
                spaceBetween: 0,
            },
            //821: {
            1301: {
                slidesPerView: 3,
                spaceBetween: 38,
            },
        },
    }

    return (
        <Swiper {...settings}>
            <div className="swiper-wrapper">
                {EVC1_SCOOTER_IMG_SWIPER_INFO.map((val, i) => (
                    <>
                        <SwiperSlide className="swiper-slide " key={'scooter-viva-img-desc-swiper-slide-' + i}>
                            <img className="img-box pc" src={val.imgUrlPc} alt="" />
                            <img className="img-box pad" src={val.imgUrlPad} alt="" />
                            <img className="img-box mobile" src={val.imgUrlMobile} alt="" />
                        </SwiperSlide>
                    </>
                ))}
            </div>
        </Swiper>
    )
}

export default ScooterEvC1SwiperFive
